"use strict";

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var _classCallCheck = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");
var _createClass = require("E:\\Projects\\shl\\shl-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[MeetingSessionCredentials]] includes the credentials used to authenticate
 * the attendee on the meeting
 */
var MeetingSessionCredentials = /*#__PURE__*/function () {
  function MeetingSessionCredentials() {
    _classCallCheck(this, MeetingSessionCredentials);
    /**
     * The attendee id for these credentials.
     */
    this.attendeeId = null;
    /**
     * The external user id associated with the attendee.
     */
    this.externalUserId = null;
    /**
     * If set, the session will be authenticated with a join token.
     */
    this.joinToken = null;
  }
  /**
   * Overrides JSON serialization so that join token is redacted.
   */
  _createClass(MeetingSessionCredentials, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        attendeeId: this.attendeeId,
        joinToken: this.joinToken === null ? null : '<redacted>'
      };
    }
  }]);
  return MeetingSessionCredentials;
}();
exports.default = MeetingSessionCredentials;